import { create } from 'zustand';
import { Location } from '../gql/graphql.generated';

interface AdminLocationState {
  actingLocation: Location | undefined;
  setActingLocation: (location: Location | undefined) => void;
}

export const useAdminLocationStore = create<AdminLocationState>()(set => {
  let currentActingLocation: Location | undefined = undefined;

  const localStored = localStorage.getItem('admin-local-storage-location');
  const storedAt = localStorage.getItem('admin-local-storage-storedAt');

  if (localStored && storedAt) {
    try {
      const storedDate = new Date(storedAt);
      const limit = new Date();
      limit.setSeconds(limit.getSeconds() - 20);

      if (storedDate >= limit) {
        currentActingLocation = JSON.parse(localStored);
      }
    } catch (error) {
      console.log('Unable to parse current acting location');
    }
  }

  return {
    actingLocation: currentActingLocation,
    setActingLocation: location => {
      localStorage.setItem('admin-local-storage-location', JSON.stringify(location));
      localStorage.setItem('admin-local-storage-storedAt', new Date().toISOString());
      set({ actingLocation: location });
    }
  };
});
